import { $Q, $Qll } from "../utils/query-selector";
import { toggleDataActive } from "../utils/toggle-dataset";


/**
 * Active toggle element for close and open menu
 * 
 * @author Andres Briñez abrinez
 */

export const openCloseMenu = () => {
  toggleDataActive('.menu-btn','#menu-wrapper__site-navigation',{ overlay: false })
}

/**
 * Display the options menu in movile versions
 * 
 * @author Andres Briñez abrinez
 */

export function readDataActive() {
  const menuElement = $Qll('.menu-link')

  menuElement.forEach(element => {

    element.addEventListener('click', () => {

      const arrow = $Q('.menu-drop-icon', element.parentNode)
      arrow.classList.toggle('rotate')

      const dropdown = $Q('.dropdown-elements', element.parentNode)
      dropdown.classList.toggle('display')
    });
  });
}

/**
 * Change modify the item of hamburguer and close
 * 
 * @author Andres Briñez abrinez
 */

export function changeItem() {
  const openButton = $Q('.open-button')
  const closeButton = $Q('.close-button')
  const buttonActive = $Qll('.menu-btn')
  const dataActive = $Q('.menu-wrapper__site-navigation');

  buttonActive.forEach(element => {
    element.addEventListener('click', () => {
      if ( dataActive.dataset.active === 'true' ) {

        openButton.classList.add('button-hiden');
        closeButton.classList.remove('button-hiden');
        
      }
      else{
        closeButton.classList.add('button-hiden');
        openButton.classList.remove('button-hiden');
      }
    });
  });
}